import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { FiUpload } from 'react-icons/fi'
import { IoMdAdd } from 'react-icons/io'
import { TiDownload } from 'react-icons/ti'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputText from '../../../components/Inputs/InputText'
import { TextArea } from '../../../components/Inputs/TextArea'
import { downloadImage } from '../../../utils/UploadFile'
import { transformDate } from '../../../utils/utils'

const EditPurchaseForm: React.FC<IEditPurchaseForm> = ({
  onSubmit,
  onCancel,
  purchase,
}) => {
  const form = useForm({
    defaultValues: {
      code: purchase?.bill?.code,
      control: purchase?.bill?.control,
      description: purchase?.bill?.description,
      date: transformDate(purchase?.bill?.date || new Date().toISOString())
    },
  })

  const [purchaseDate, setPurchaseDate] = useState<string | null>(null)

  useEffect(() => {
    setPurchaseDate(
      purchase?.bill?.date ? transformDate(purchase?.bill?.date, false) : null
    )
  }, [])
  

  let inputSubmitFileRef = useRef<HTMLInputElement | null>(null)
  const [document, setDocument] = useState<File | null>(null)

  const onSubmitImage = (e): void => {
    e.preventDefault()
    if (inputSubmitFileRef.current && inputSubmitFileRef.current.files) {
      setDocument(inputSubmitFileRef?.current?.files[0])
    }
  }

  useEffect(() => {
    console.log("document..", document)
  }, [document])

  return (
    <Form
      form={form}
      onSubmit={(values) => onSubmit({ ...values, document })}
      classes="gap-x-2 p-2"
    >
      <input type="file" ref={inputSubmitFileRef} onChange={onSubmitImage} />
      <h2 className="col-span-11 mb-5 ml-5 text-primary dark:text-white font-bold text-3xl">
        Editar / Añadir Factura
      </h2>
      {/* <div
        style={{
          height: 40,
          width: 40,
          borderRadius: 8,
          backgroundColor: '#006AEA',
        }}
        className="flex flex-row items-center justify-center cursor-pointer"
        onClick={() =>
          inputSubmitFileRef.current && inputSubmitFileRef.current.click()
        }
      >
        <FiUpload className="text-white" />
      </div> */}

      <FormItem name="code" classes="xl:col-span-4 lg:col-span-12">
        <InputText
          small
          label="Código en documento"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem name="control" classes="xl:col-span-4 lg:col-span-12">
        <InputText
          small
          label="Número de control"
          maxLength={80}
          isUpperValue={false}
        />
      </FormItem>

      <FormItem
        defaultValue={purchaseDate}
        name="date"
        classes="xl:col-span-4 lg:col-span-12 mt-1"
      >
        <Datepicker label="Fecha de creación" />
      </FormItem>

      <div className="flex flex-row col-span-12 justify-end my-2">
        <IoMdAdd className="text-primary" />
        <u
          className="text-xs text-primary cursor-pointer"
          onClick={() =>
            inputSubmitFileRef.current && inputSubmitFileRef.current.click()
          }
          style={{ color: '#006AEA', cursor: 'pointer' }}
        >
          Subir documento
        </u>
      </div>


      <div className='flex col-span-12 flex-row justify-end'>
        <label style={{maxWidth: 200}} className='truncate text-xs'>{document?.name}</label>
      </div>

      <FormItem name="description" classes="lg:col-span-12 col-span-12">
        <TextArea
          label="Notas"
          placeholder="Notas adicionales de las notas de entrega."
          isUpperValue={false}
        />
      </FormItem>

      <div className="flex flex-row col-span-12 justify-end my-2 mt-5">
        <TiDownload className="text-primary mr-1" />
        <u
          className="text-xs text-primary cursor-pointer"
          onClick={() => {
            // window.open(purchase?.bill?.document)
            // downloadImage(purchase?.bill?.document)
            downloadImage(purchase?.bill?.document)
          }
          }
          style={{ color: '#006AEA', cursor: 'pointer', textDecoration: "none" }}
        >
          Descargar documento
        </u>
      </div>


      <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Guardar Cambios
        </Button>
      </div>
    </Form>
  )
}

export interface IEditPurchaseForm {
  onSubmit: (values: any) => void
  onCancel: () => void
  purchase: any
}

export default EditPurchaseForm
